import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 bg-navy-900 border-t border-white/5" data-id="element-62">
      <div className="max-w-4xl mx-auto text-center" data-id="element-63">
        <p className="text-white/30 text-xs leading-relaxed" data-id="element-64">
          Producto digital independiente. Edición no oficial. No afiliado a AFA,
          FIFA ni Mattel. Disponible únicamente durante el período del Mundial
          2026.
        </p>
      </div>
    </footer>;
}